var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcContentRating12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_91)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.976,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.81034 -0.258621C10.4311 -0.258621 19.0517 -0.258621 27.6724 -0.258621C28.3422 0.252604 29.0319 0.769846 29.7414 1.2931C29.7414 10.2586 29.7414 19.2242 29.7414 28.1897C29.0517 28.5345 28.5345 29.0517 28.1897 29.7414C19.2242 29.7414 10.2586 29.7414 1.2931 29.7414C0.948274 29.0517 0.431034 28.5345 -0.258621 28.1897C-0.258621 19.3966 -0.258621 10.6034 -0.258621 1.81034C0.25862 0.948274 0.948274 0.25862 1.81034 -0.258621Z",
    fill: "#D0D155"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1207 21.9828C26.1207 23.3621 26.1207 24.7414 26.1207 26.1207C22.3276 26.1207 18.5345 26.1207 14.7414 26.1207C14.7414 25.0862 14.7414 24.0517 14.7414 23.0172C16.3745 20.7911 18.0125 18.5497 19.6552 16.2931C21.6303 13.5306 21.8889 10.6857 20.431 7.75862C18.6983 7.27764 17.2328 7.70871 16.0345 9.05172C15.6752 7.90236 15.2442 6.78171 14.7414 5.68966C15.9039 4.03172 17.5418 3.25586 19.6552 3.36207C24.0034 3.48628 26.1586 5.72767 26.1207 10.0862C25.54 14.6095 23.6435 18.4888 20.431 21.7241C22.3198 21.982 24.2164 22.0683 26.1207 21.9828Z",
    fill: "#FDFDF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.01725 3.36207C9.22413 3.36207 10.4311 3.36207 11.6379 3.36207C11.6379 11.1207 11.6379 18.8793 11.6379 26.6379C10.2586 26.6379 8.87933 26.6379 7.50001 26.6379C7.67183 20.5936 7.49944 14.5592 6.98277 8.53448C6.20644 9.18181 5.3444 9.69905 4.39656 10.0862C3.98682 9.06993 3.64199 8.03545 3.36208 6.98276C4.83581 5.64636 6.38752 4.43947 8.01725 3.36207Z",
    fill: "#FDFDFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1207 21.9828C26.6259 23.4243 26.7983 24.976 26.6379 26.6379C22.5 26.6379 18.3621 26.6379 14.2241 26.6379C14.0681 25.3142 14.2406 24.1073 14.7414 23.0172C14.7414 24.0517 14.7414 25.0862 14.7414 26.1207C18.5345 26.1207 22.3276 26.1207 26.1207 26.1207C26.1207 24.7414 26.1207 23.3621 26.1207 21.9828Z",
    fill: "#E9EAB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_91"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContentRating12);
export default __webpack_public_path__ + "static/media/ic_content_rating_12.55e37796fc098e66286dc0541b225ef2.svg";
export { ForwardRef as ReactComponent };